import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import { StyledCollapsiblePanelHead } from "app/pages/sales-intelligence/common-components/collapsible-panel";

export const StyledFilterCollapsiblePanelHead = styled(StyledCollapsiblePanelHead)`
    padding: 8px 8px 8px 12px;
    flex-grow: 0;
`;

export const StyledFiltersPanelWrapper = styled(Stack)`
    flex-grow: 1;
    min-height: 0;
`;

export const StyledFiltersPanelContentWrapper = styled(Stack)`
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden;
`;
